import { getMessages } from '../../../../../../store/constants';

export const CHAT_VIEW = getMessages().getText('nav_panel.chats');
